module.exports = __webpack_public_path__ + "static/media/tv-music.0c7760d3.svg";